import type { ErrorEvent, EventHint } from "@sentry/core"

/**
 * Expected auth errors (user not logged in / not authorized) are normal app flow,
 * not bugs. Drop them so they don't create Sentry noise. Shared by the server
 * (sentry.server.config.ts) and client (observability) SDK inits so the two stay in sync.
 */
export const dropExpectedAuthErrors = (event: ErrorEvent, hint: EventHint): ErrorEvent | null => {
  const name = hint?.originalException instanceof Error ? hint.originalException.name : ""
  if (name === "AuthenticationError" || name === "AuthorizationError") {
    return null
  }
  return event
}
